import React from 'react'
import { createRoot } from 'react-dom/client'
import { CourseLoadingApp } from './App'

export let startCourseLoadingApp = (
  templateCoursenum,
  newCoursenum,
  instrId,
  targetUrl,
) => {
  const root = createRoot(document.getElementById('app'))
  root.render(
    <CourseLoadingApp
      templateCoursenum={templateCoursenum}
      newCoursenum={newCoursenum}
      instrId={instrId}
      targetUrl={targetUrl}
    />
  )
}
